export enum LivestreamType {
  HLS = 'HLS',
  RTMP = 'RTMP',
}

export const headerInfo = {
  [LivestreamType.HLS]: {
    title: 'HLS Live Stream',
    subTitle: 'Enter the url source for the audio and/or video you would like to stream',
  },
  [LivestreamType.RTMP]: {
    title: 'RTMP Live Stream',
    subTitle: 'Enter the url source for the audio and/or video you would like to stream',
  },
  preview: {
    title: 'Preview',
    subTitle: '',
  },
  default: {
    title: 'Live Stream',
    subTitle: 'Select the livestream type ',
  },
};

export const livestreamError = {
  error: 'That stream url is unavailable or incorrect. Please try again.',
};

export enum CurrentView {
  SELECT_PRESENTERS = 'select_presenters',
  MANAGE_PRESENTERS = 'manage_presenters',
}
